module.exports = __webpack_public_path__ + "static/media/airtel.debd4694.svg";